import { httpBackOfficeUtil } from "./httpBackOfficeUtil";
import { ErrorCodes, createResult, createCommonResult } from "./resultUtil";

export const contacts = {
    getContact,
}

async function getContact(id) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: "/v2/contacts/" + id,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}